export default __webpack_public_path__ + "static/media/javascript.19600440.svg";